<script>
import BrandLayout from './components/Layout'
import SectionCase from '@views/Brand/components/Item/SectionCase'
import SectionCourses from '@views/Brand/components/Item/SectionCourses'
import SectionFile from '@views/Brand/components/Item/SectionFile'
import SectionNews from '@views/Brand/components/Item/SectionNews'
import SectionProduct from '@views/Brand/components/Item/SectionProduct'
import SectionProfile from '@views/Brand/components/Item/SectionProfile'
import SectionSolution from '@views/Brand/components/Item/SectionSolution'
import SectionVideo from '@views/Brand/components/Item/SectionVideo'

import Anchor from '@views/Brand/components/Item/Anchor'
import { brandComputed } from '@store/helpers'

import { conditionList } from '@utils/is-condition'
import pageGAMixin from './mixins/pageGA'
import Box from '@components/List/Box'

export default {
  page() {
    return {
      title: `${this.currentBrand.title}`,
    }
  },
  components: {
    BrandLayout,
    SectionVideo,
    SectionSolution,
    SectionProfile,
    SectionProduct,
    SectionNews,
    SectionFile,
    SectionCourses,
    SectionCase,
    Anchor,
    Box,
  },
  mixins: [pageGAMixin],
  data() {
    return {
      // courseList: COURSE_LIST,
    }
  },
  computed: {
    ...brandComputed,
    brandMenuList() {
      const routerMap = {
        solution: {
          name: 'brand-solution-list',
          icon: '<i class="icomoon icon-primary-solution"></i>',
        },
        product: {
          name: 'brand-product-list',
          icon: '<i class="icomoon icon-gray-product color-primary"></i>',
        },
        event: {
          name: 'brand-event-list',
          icon: '<i class="icomoon icon-primary-event"></i>',
        },
        news: {
          name: 'brand-news-list',
          icon: '<i class="icomoon icon-primary-news"></i>',
        },
        case: {
          name: 'brand-case-list',
          icon: '<i class="icomoon icon-primary-case"></i>',
        },
        file: {
          name: 'brand-file',
          icon: '<i class="icomoon icon-primary-download"></i>',
        },
        video: {
          name: 'brand-video-list',
          icon: '<i class="icomoon icon-primary-viedo"></i>',
        },
      }
      const tabs = this.currentBrand.tabs
      const result = tabs.map((item) => {
        return {
          text: item.title,
          id: item.alias,
          to: {
            name: routerMap[item.alias].name,
          },
          icon: routerMap[item.alias].icon,
        }
      })
      if (this.currentBrand.description) {
        const info = {
          text: '品牌介紹',
          id: 'profile',
          to: {
            name: 'brand-introduce',
          },
          icon: '<i class="icomoon icon-primary-brand"></i>',
        }
        return [info, ...result]
      } else {
        return result
      }
    },
    sectionList() {
      return conditionList([
        {
          text: '品牌介紹',
          id: 'profile',
          condition: () => {
            return !!this.currentBrand.description
          },
        },
        {
          text: '最新消息',
          id: 'news',
          condition: () => {
            return !!this.currentBrand.items.promotion[0] || !!this.currentBrand.items.bulletin[0]
          },
        },
        {
          text: '課程活動',
          id: 'event',
          condition: () => {
            return !!this.currentBrand.events[0]
          },
        },
        {
          text: '產品系列',
          id: 'product',
          condition: () => {
            return !!this.currentBrand.products[0]
          },
        },
        {
          text: '解決方案',
          id: 'solution',
          condition: () => {
            return !!this.currentBrand.items.solution[0]
          },
        },
        {
          text: '成功案例',
          id: 'case',
          condition: () => {
            return !!this.currentBrand.items.case[0]
          },
        },
        {
          text: '檔案下載',
          id: 'file',
          condition: () => {
            return !!this.currentBrand.files[0]
          },
        },
        {
          text: '產品影片',
          id: 'video',
          condition: () => {
            return !!this.currentBrand.items.video[0]
          },
        },
      ])
    },
  },
  mounted() {
    this.currentBrand.tabs.forEach((el, index) => {
      if (index % 2 === 0) el.color = 'white'
      else el.color = 'gray'
    })
    this.sectionList.forEach((el, index) => {
      this.currentBrand.tabs.forEach((child, childIndex) => {
        if (child.alias === el.id) {
          el.color = child.color
        }
      })
    })
    // this.currentBrand.tabs.forEach((el,index) => {
    //   if(index === 0 ){

    //   }
    // })
  },
  methods: {
    /* checkCanDownload(list) {
        const result = list.filter((item) => {
          return item.canDownload
        });

        if(result.length > 3) {
          result.length = 3
        }

        return result
      }, */
  },
}
</script>
<template>
  <BrandLayout>
    <div class="d-md-block d-none">
      <template v-if="!!sectionList[0]">
        <!--品牌介紹-->
        <SectionProfile v-if="!!currentBrand.description" :text="currentBrand.description" />
        <!--最新消息-->
        <SectionNews v-if="!!currentBrand.items.promotion[0] || !!currentBrand.items.bulletin[0]" :bulletin="currentBrand.items.bulletin" :promotion="currentBrand.items.promotion" />
        <!--課程活動-->
        <SectionCourses v-if="!!currentBrand.events[0]" :event-list="currentBrand.events" />
        <!--產品系列-->
        <SectionProduct v-if="!!currentBrand.products[0]" :list="currentBrand.products" />
        <!--解決方案-->
        <SectionSolution v-if="!!currentBrand.items.solution[0]" :list="currentBrand.items.solution" />
        <!--成功案例-->
        <SectionCase v-if="!!currentBrand.items.case[0]" :list="currentBrand.items.case" />
        <!--檔案下載-->
        <SectionFile v-if="!!currentBrand.files[0]" :list="currentBrand.files" />
        <!--產品影片-->
        <SectionVideo v-if="!!currentBrand.items.video[0]" :list="currentBrand.items.video" />
        <Anchor :anchor-list="sectionList" />
      </template>
      <template v-else>
        <div class="section">
          <div class="container">
            <BaseNull content="<p class='my-0'>目前此品牌首頁無任何資料</p> <p class='mb-0 mt-3'>點擊上方按鈕查看其他資訊或者點擊下方按鈕，探索更多資訊</p>">
              <BaseButton class="isStylePrimary isCol4 isRadius mt-5" :to="{ name: 'brand-list' }"> 探索其他品牌 </BaseButton>
            </BaseNull>
          </div>
        </div>
      </template>
      <BasePre>{{ currentBrand }}</BasePre>
    </div>
    <div class="d-md-none container">
      <div class="row">
        <template v-for="(menu, index) in brandMenuList">
          <Box :key="`menu-${index}`" class="col-4 mt-3 isStyleNoShadow" :item="menu" />
        </template>
      </div>
    </div>
  </BrandLayout>
</template>
